import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FeatureFlagsConfig } from './featureFlags.model';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CORE_CONFIGURATION } from '../../configuration';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  private config$:Promise<FeatureFlagsConfig>;
  private aemPath:string = '/content/myvf-business/configurations/features.contents.json';

  constructor(private http: HttpClient, @Inject(CORE_CONFIGURATION) private config) {
    const urlAem = this.config.aemBasePath+this.aemPath;
    this.config$ = this.http.get<FeatureFlagsConfig>(urlAem).pipe(catchError(error => { console.error('Failed to load feature flags :', error); return of({ features: [] } as FeatureFlagsConfig); })).toPromise();
  }

  /**
   *
   * @param id
   * controlla se la feature flag esiste e se abilitata. true = abilitata ed esistente
   */
  async check(id: string) {
    const config = await this.config$;
    return config.features.some((featureFlag)=>featureFlag.id === id && featureFlag.enabled).valueOf();
  }
}
